// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1dlEN","top":"styles_top__I2Z7_","left":"styles_left__3VNJb","description":"styles_description__2isbb"};